import axios from 'axios'
import { saveAs } from 'file-saver'

export const downloadFile = async ({ url, type, options, name = 'CRM', callback }) => {
  if (type.toString().toUpperCase() === 'PDF' || type.toString().toUpperCase() === 'EXCEL') {
    try {
      let filename = name
      filename += type.toString().toUpperCase() === 'EXCEL' ? '.xlsx' : '.pdf'

      const newOptions = { ...options, exportType: type }
      await axios.get(url, { params: { ...newOptions }, responseType: 'blob' }).then((res) => {
        if (res.status === 200) {
          saveAs(new Blob([res.data]), filename)
        }
      })
    } catch (error) {
    } finally {
      typeof callback === 'function' && callback()
    }
  }
}

export const downloadAttachment = async ({ url, key, type, options = {}, name = 'CRM', callback }) => {
  try {
    let filename = name

    await axios
      .post(url, { key }, { responseType: 'blob' })
      .then((res) => {
        if (res.status === 200) {
          saveAs(new Blob([res.data]), filename)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  } catch (error) {
  } finally {
    typeof callback === 'function' && callback()
  }
}
